import React, {useEffect, useState} from "react";
import {SettingsButtonsMethods} from "@/views/Admin/Events/Event/Registration/SettingsButtons/SettingsButtons.methods";
import RegistrationColor from "@/components/RegistrationColors";
import {deserializedData} from "@/utils/deserializedData";
import {useParams} from "react-router-dom";
import {ButtonAttributes} from "./SettingsButtons.interface";
import {useToast} from "uikit";
import Colors from "../Form/Colors/Colors";

const SettingsButtons: React.FC = () => {
    const {getButtons, createButtons, patchButtons, deleteButtons} = SettingsButtonsMethods;
    const [sortableData, setSortableData] = useState<ButtonAttributes[] | null>(null);
    const [nonSortableData, setNonSortableData] = useState<ButtonAttributes[] | null>(null);
    const [preloader, setPreloader] = useState<boolean>(true);
    const params = useParams<{ id: string, type_event_id: string }>();
    const addToast = useToast();
    useEffect(() => {
        initData();
    }, []);

    const initData = async () => {
        try {
            const response = await getButtons(params.id, params.type_event_id);
            const deserialized: ButtonAttributes[] = await deserializedData(response.data);
            const sortable = deserialized.filter((button) => button.sortable);
            const nonSortable = deserialized.filter((button) => !button.sortable);
            setSortableData(sortable);
            setNonSortableData(nonSortable);
        } catch (e) {
            console.error(e);
        } finally {
            setPreloader(false);
        }
    };

    const handlerCreateButtons = async (fields) => {
        try {
            const promises = fields.map(f => {
                if (!f.id) {
                    return createButtons(f, params.id, params.type_event_id);
                } else {
                    return patchButtons(f, params.id, params.type_event_id);
                }
            });


            const results = await Promise.all(promises);
            addToast({
                message: 'Успешно сохранено',
                type: 'success',
                duration: 3000,
            });
            initData()
        } catch (e) {
            console.log(e.response ? e.response.data : e.message);
            addToast({
                message: 'Ошибка сохранения',
                type: 'danger',
                duration: 3000,
            });
        }
    };

    const handlerDelete = async (id) => {
        try {
            const results = await deleteButtons(id)
            addToast({
                message: 'Успешно сохранено',
                type: 'success',
                duration: 3000,
            });
            initData()
        } catch (e) {
            console.log(e.response ? e.response.data : e.message);
            addToast({
                message: 'Ошибка сохранения',
                type: 'danger',
                duration: 3000,
            });
        }

    }

    const handlers = {
        handlerCreateButtons: handlerCreateButtons,
        handlerDelete: (field) => handlerDelete(field.id)
    }

    return (
        <div className={'paymentsContainer'}>
            {/* Передаем сортируемые и не сортируемые кнопки в разные компоненты */}
            <div>
                <h2>Кнопки методов оплаты</h2>
                <RegistrationColor
                    data={sortableData}
                    handlers={handlers}
                    sortable={true}
                />
            </div>

            <div>
                <h2>Остальные кнопки</h2>
                <RegistrationColor
                    data={nonSortableData}
                    handlers={handlers}
                    sortable={false}
                />
            </div>
        </div>
    );
};

export default SettingsButtons;
